/**
 * users模块接口列表
 */
import Vue from "vue";
import axios from '@/utils/http';
const users = {
  /**
   * 得到指定人员信息
   * userid: 用户id（员编）
   * params：mode=c(ciy)，s（供应商）
   */
  other(params,userid) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/users/`+userid, {
      params: params,
      mask:false
    });
  },
  //得到供应商信息{code+name}
  signVendor(vendor) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/users/sign/`+vendor, {
      mask:false
    });
  },
  //得到供应商信息{code+name}
  confirmUser(userId) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/confirm-user/`+userId, {
      mask:false
    });
  }
}

export default users;



// WEBPACK FOOTER //
// ./src/api/users.js